export default {
  common: {
    systemNameSuffix: '智能客服管理系统', // 固定后缀
    dashboard: '仪表盘',
    confirm: '确认',
    cancel: '取消',
    submit: '提交',
    reset: '重置',
    search: '搜索',
    delete: '删除',
    edit: '编辑',
    add: '添加',
    save: '保存',
    back: '返回',
    loading: '加载中...',
    success: '操作成功',
    error: '操作失败',
    warning: '警告',
    info: '提示',
    second: '秒',
    actions: '操作',
    selectFile: '选择文件',
    refresh: '刷新',
    close: '关闭',
    description: '描述'
  },
  login: {
    title: '欢迎登录',
    subtitle: '请输入您的账号和密码',
    username: '用户名',
    password: '密码',
    usernamePlaceholder: '请输入用户名',
    passwordPlaceholder: '请输入密码',
    rememberMe: '记住我',
    forgotPassword: '忘记密码？',
    loginButton: '登录',
    loggingIn: '登录中...',
    forgotPasswordTitle: '找回密码',
    forgotPasswordDesc: '请输入您的账号和邮箱地址，我们将发送验证码到您的邮箱。',
    forgotPasswordStep2Desc: '请输入验证码和新密码',
    email: '邮箱地址',
    emailPlaceholder: '请输入注册邮箱',
    sendResetLink: '发送重置链接',
    sendVerifyCode: '发送验证码',
    resendCode: '重新发送',
    resendAfter: '{seconds}秒后重发',
    verifyCode: '验证码',
    verifyCodePlaceholder: '请输入6位验证码',
    icpLabel: '备案号：',
    newPassword: '新密码',
    newPasswordPlaceholder: '请输入新密码（至少6位）',
    confirmPassword: '确认密码',
    confirmPasswordPlaceholder: '请再次输入新密码',
    resetPassword: '重置密码',
    resetting: '重置中...',
    sending: '发送中...'
  },
  message: {
    loginSuccess: '登录成功',
    loginFailed: '登录失败',
    loginExpired: '登录已过期，请重新登录',
    sendFailed: '发送失败',
    networkError: '网络连接失败，请检查网络',
    pleaseEnterUsername: '请输入用户名',
    pleaseEnterPassword: '请输入密码',
    pleaseEnterEmail: '请输入邮箱地址',
    usernameOrPasswordError: '用户名或密码错误',
    accountLocked: '账号已被锁定，请稍后再试',
    tenantNotFound: '租户不合法',
    accountOrEmailError: '账号或邮箱错误',
    emailNotSet: '该账号未设置邮箱，请联系管理员',
    emailSendFailed: '密码已重置，但邮件发送失败，请联系管理员',
    passwordResetSent: '密码已发送到对应邮箱',
    passwordResetSuccess: '密码重置成功',
    pleaseFillAllFields: '请填写所有字段',
    passwordTooShort: '密码长度不能少于6位',
    passwordMismatch: '新密码和确认密码不一致',
    verifyCodeError: '验证码错误或已过期',
    verifyCodeRateLimit: '验证码发送频率过高，请稍后再试',
    verifyCodeSent: '验证码已发送，请查收邮件'
  },
  menu: {
    dashboard: '仪表盘',
    systemConfig: '系统配置',
    conversations: '问答记录',
    feedbackRecords: '反馈记录',
    modelAnnotation: '模型标注',
    modelTraining: '模型训练',
    knowledgeBase: '知识库管理',
    userManagement: '用户管理',
    systemPrompt: '提示词设置',
    modelConfig: '模型配置',
    oneClickUpdate: '一键更新'
  },
  update: {
    checkingOrRunning: '检测中...',
    confirmTitle: '确认一键更新',
    confirmMessage: '以下项目需要更新：{list}。\n\n更新将拉取最新代码并可能重启相关服务。仅管理端后端、客户端后端会短暂断开连接（管理端前端、客户端前端不受影响）。请约 1～2 分钟后刷新页面或重新登录。\n\n是否继续？',
    adminServer: '管理端后端',
    customerServer: '客户端后端',
    adminFrontend: '管理端前端',
    customerFrontend: '客户端前端',
    yoloService: 'YOLO 服务',
    agent: 'Agent',
    checkFailed: '检测失败',
    alreadyLatest: '当前已是最新，无需更新',
    triggerFailed: '启动更新失败',
    updateInProgress: '更新正在进行中，请勿重复操作。',
    operationFailed: '操作失败',
    triggerSuccess: '更新已启动，请约 1～2 分钟后刷新页面或重新登录。'
  },
  header: {
    logout: '退出登录',
    profile: '个人信息'
  },
  profile: {
    title: '个人信息',
    titleRequired: '请设置邮箱',
    username: '账号',
    currentPassword: '当前密码',
    newPassword: '新密码',
    confirmPassword: '确认新密码',
    email: '邮箱',
    currentPasswordPlaceholder: '请输入当前密码进行验证',
    newPasswordPlaceholder: '请输入新密码',
    confirmPasswordPlaceholder: '请再次输入新密码',
    emailPlaceholder: '请输入邮箱地址',
    save: '保存',
    cancel: '取消',
    saving: '保存中...',
    currentPasswordRequired: '请输入当前密码',
    newPasswordRequired: '请输入新密码',
    confirmPasswordRequired: '请再次输入新密码',
    emailRequired: '请输入邮箱地址',
    passwordMinLength: '密码长度至少6位',
    passwordMismatch: '新密码和确认密码不一致',
    emailFormatError: '邮箱格式不正确',
    updateSuccess: '修改成功',
    updateFailed: '修改失败',
    // 具体的错误原因
    errorCurrentPasswordWrong: '当前密码错误',
    errorPasswordMismatch: '新密码和确认密码不一致',
    errorEmailFormat: '邮箱格式不正确',
    errorPasswordTooShort: '密码长度至少6位',
    errorNotOwnInfo: '只能修改自己的信息',
    errorNotLoggedIn: '未登录或登录已过期',
    errorUpdateFailed: '修改失败，请稍后重试',
    verifyCode: '验证码',
    verifyCodePlaceholder: '请输入6位验证码',
    sendVerifyCode: '发送验证码',
    sendingVerifyCode: '发送中...',
    verifyCodeSent: '验证码已发送，请查收邮件',
    verifyCodeRequired: '请输入验证码',
    verifyCodeLength: '验证码必须为6位数字',
    verifyCodeError: '验证码错误或已过期',
    verifyCodeRateLimit: '验证码发送频率过高，请稍后再试',
    verifyCodeSendFailed: '验证码发送失败，请稍后重试',
    errorVerifyCodeError: '验证码错误或已过期',
    errorVerifyCodeRateLimit: '验证码发送频率过高，请稍后再试',
    errorVerifyCodeSendFailed: '验证码发送失败，请稍后重试',
    resendAfter: '后重发'
  },
  dashboard: {
    welcome: '欢迎使用智能客服管理系统',
    totalConversations: '总会话数',
    totalMessages: '总消息数',
    todayConversations: '今日会话',
    todayMessages: '今日消息',
    dailyStatistics: '每日统计',
    last7Days: '最近7天',
    last30Days: '最近30天',
    last7DaysTrend: '最近7天趋势',
    last30DaysTrend: '最近30天趋势',
    conversationCount: '会话数',
    messageCount: '消息数'
  },
  pages: {
    systemConfig: {
      description: '配置ASR、TTS、OpenAI、对象存储等系统参数',
      placeholder: '系统配置页面（待开发）'
    },
    conversations: {
      description: '查看和管理所有会话记录',
      placeholder: '问答记录页面（待开发）'
    },
    modelAnnotation: {
      title: '模型标注',
      description: '使用 Label Studio 进行数据标注，标注后的数据可用于模型训练'
    },
    modelTraining: {
      description: '上传标注数据，训练自定义模型',
      placeholder: '模型训练页面（待开发）'
    },
    knowledgeBase: {
      description: '管理知识库文档',
      placeholder: '知识库管理页面（待开发）'
    },
    userManagement: {
      description: '管理系统用户账号',
      placeholder: '用户管理页面（待开发）'
    },
    systemPrompt: {
      description: '配置提示词，用于AI对话的初始引导',
      placeholder: '提示词设置页面（待开发）',
      promptEditor: '提示词设置',
      promptHint: '提示词用于AI对话的初始引导。您可以使用变量占位符，例如 {0} 表示知识库内容，系统会在对话时自动替换为实际的知识库信息。',
      chatTest: '对话测试',
      promptPlaceholder: '请输入提示词模板...',
      savePrompt: '保存',
      saveSuccess: '提示词保存成功',
      saveFailed: '提示词保存失败',
      loadFailed: '加载提示词失败',
      promptRequired: '提示词不能为空',
      chatPlaceholder: '对话测试功能开发中...',
      inputPlaceholder: '请输入消息...',
      send: '发送',
      chatFailed: '对话失败，请稍后重试'
    }
  },
  systemConfig: {
    companyInfo: '公司信息',
    companyNameCn: '公司简称',
    companyNameCnPlaceholder: '请输入公司简称（中文）',
    companyNameCnRequired: '请输入公司简称（中文）',
    companyNameEn: '公司简称（英文）',
    companyNameEnPlaceholder: '请输入公司简称（英文）',
    companyNameEnRequired: '请输入公司简称（英文）',
    companyFullNameCn: '公司全称（中文）',
    companyFullNameCnPlaceholder: '请输入公司全称（中文），用于用户协议和隐私条款的署名',
    companyFullNameCnRequired: '请输入公司全称（中文）',
    companyFullNameEn: '公司全称（英文）',
    companyFullNameEnPlaceholder: '请输入公司全称（英文），用于用户协议和隐私条款的署名',
    companyFullNameEnRequired: '请输入公司全称（英文）',
    adminDomain: '管理端域名',
    adminDomainRequired: '管理端域名不能为空',
    clientDomain: '客户端域名',
    clientDomainRequired: '客户端域名不能为空',
    wikiDomain: 'Wiki域名',
    wikiDomainRequired: 'Wiki域名不能为空',
    companyLogoUrl: '管理端封面图',
    companyLogoUrlPlaceholder: '请输入管理端封面图URL',
    companyLogoUrlRequired: '请输入管理端封面图URL',
    companyLogo: '公司LOGO',
    companyLogoPlaceholder: '请输入公司LOGO URL',
    companyLogoRequired: '请输入公司LOGO URL',
    uploadImage: '点击上传',
    uploadImageButton: '上传图片',
    imageUploading: '正在上传...',
    imageUploadSuccess: '图片上传成功',
    imageUploadFailed: '图片上传失败',
    imageUploadError: '图片上传失败，请重试',
    imageTypeError: '只能上传图片文件！',
    imageSizeError: '图片大小不能超过 5MB！',
    coverImageUploadSuccess: '封面图上传成功',
    logoUploadSuccess: 'LOGO上传成功',
    imagePreview: '图片预览',
    reUpload: '重新上传',
    clickToUpload: '点击上传图片',
    icpNumber: 'ICP备案号',
    icpNumberPlaceholder: '请输入ICP备案号（如：京ICP备12345678号）',
    speechConfig: '语音配置（ASR/TTS）',
    speechConfigDesc: 'ASR（语音识别）和TTS（语音合成）共用以下配置',
    testAsr: '测试ASR',
    testTts: '测试TTS',
    storageConfig: '对象存储配置',
    modelConfig: '模型设置',
    modelConfigDesc: '使用自部署模型名称建议使用公司英文简称，例如：JC_AI',
    selectDeployedModel: '选择已部署模型',
    selectDeployedModelPlaceholder: '请选择已部署的模型',
    azureSpeechKey: 'Azure Speech API Key',
    azureSpeechKeyPlaceholder: '请输入Azure Speech API Key',
    azureSpeechKeyRequired: '请输入Azure Speech API Key',
    azureSpeechEndpoint: 'Azure Speech端点',
    azureSpeechEndpointPlaceholder: '请输入Azure Speech端点（如：https://westus2.api.cognitive.microsoft.com/）',
    azureSpeechEndpointRequired: '请输入Azure Speech端点',
    azureSpeechRegion: 'Azure Speech区域',
    azureSpeechRegionPlaceholder: '请输入Azure Speech区域（如：westus2）',
    azureSpeechRegionRequired: '请输入Azure Speech区域',
    azureStorageEndpoint: 'Azure存储端点',
    azureStorageEndpointPlaceholder: '请输入Azure存储端点（如：https://jcaistorage.blob.core.windows.net）',
    azureStorageEndpointRequired: '请输入Azure存储端点',
    azureStorageAccountName: 'Azure对象存储账号',
    azureStorageAccountNamePlaceholder: '请输入Azure对象存储账号',
    azureStorageAccountNameRequired: '请输入Azure对象存储账号',
    azureStorageAccountKey: 'Azure对象存储密钥',
    azureStorageAccountKeyPlaceholder: '请输入Azure对象存储密钥',
    azureStorageAccountKeyRequired: '请输入Azure对象存储密钥',
    azureOpenaiDeploymentName: 'Azure OpenAI部署名称',
    azureOpenaiDeploymentNamePlaceholder: '请输入Azure OpenAI部署名称（如：gpt-4o）',
    azureOpenaiDeploymentNameRequired: '请输入Azure OpenAI部署名称',
    azureOpenaiApiBase: 'Azure OpenAI API Base',
    azureOpenaiApiBasePlaceholder: '请输入Azure OpenAI API域名（如：https://jcaiserver-openai.openai.azure.com/）',
    azureOpenaiApiBaseRequired: '请输入Azure OpenAI API Base',
    azureOpenaiApiKey: 'Azure OpenAI API Key',
    azureOpenaiApiKeyPlaceholder: '请输入Azure OpenAI API Key',
    azureOpenaiApiKeyRequired: '请输入Azure OpenAI API Key',
    azureOpenaiApiVersion: 'Azure OpenAI API版本',
    azureOpenaiApiVersionPlaceholder: '请输入Azure OpenAI API版本（如：2024-12-01-preview）',
    azureOpenaiApiVersionRequired: '请输入Azure OpenAI API版本',
    azureOpenaiBaseModelName: 'OpenAI基础模型版本',
    azureOpenaiBaseModelNamePlaceholder: '请输入OpenAI基础模型名称（如：gpt-4o）',
    azureOpenaiBaseModelNameRequired: '请输入OpenAI基础模型版本',
    test: '测试',
    save: '保存',
    saving: '保存中...',
    loadFailed: '加载配置失败',
    saveSuccess: '配置保存成功',
    saveFailed: '配置保存失败',
    configTestFailed: '配置测试失败',
    pleaseFillAsrConfig: '请先填写ASR配置',
    pleaseFillTtsConfig: '请先填写TTS配置',
    pleaseFillStorageConfig: '请先填写对象存储配置',
    asrTestSuccess: 'ASR测试成功',
    asrTestFailed: 'ASR测试失败',
    asrConfigError: 'ASR配置错误，请检查 Azure Speech API Key 和 Azure Speech 配置',
    ttsTestSuccess: 'TTS测试成功',
    ttsTestFailed: 'TTS测试失败',
    ttsConfigError: 'TTS配置错误，请检查 Azure Speech API Key 和 Azure Speech 配置',
    storageTestSuccess: '对象存储测试成功',
    storageTestFailed: '对象存储测试失败',
    storageConfigError: '对象存储配置错误，请检查 Azure Storage 配置',
    testModel: '部署模型',
    modelTestSuccess: '模型部署成功',
    modelTestFailed: '模型部署失败',
    modelConfigError: '模型配置错误，请检查 Azure OpenAI 配置',
    modelTestNotPassed: '请先完成模型部署并确保部署通过',
    pleaseFillModelConfig: '请先填写完整的模型配置信息',
    useJiecangConfig: '使用捷昌配置',
    ownConfig: '自有配置',
    useJiecangDeployment: '使用捷昌模型',
    ownDeployment: '自有部署',
    jiecangConfigTip: '当前使用捷昌配置，无需填写和测试',
    jiecangDeploymentTip: '当前使用捷昌模型，无需填写和测试',
    asrTestNotPassed: '请先完成ASR测试并确保测试通过',
    ttsTestNotPassed: '请先完成TTS测试并确保测试通过',
    storageTestNotPassed: '请先完成对象存储测试并确保测试通过',
    // Wiki知识库配置
    wikiKnowledgeBase: 'Wiki知识库',
    wikiKbMode: '知识库导入模式',
    wikiKbModeAll: '所有页面',
    wikiKbModeTags: '指定Tags标签',
    wikiKbTags: 'Tags标签',
    wikiKbTagsDesc: '例如：公司,产品,售后 最多10个tags',
    wikiKbTagPlaceholder: '请输入标签名称',
    addTag: '添加标签',
    wikiKbTagsTip: '当前 {count} 个标签，最多 {max} 个',
    wikiKbTagsRequired: '请至少添加一个标签',
    wikiKbTagsMaxLimit: '最多只能添加10个标签',
    wikiKbTagsNotEmpty: '标签不能为空',
    wikiKbTagsNoDuplicate: '标签不能重复'
  },
    modelConfig: {
    title: '模型配置',
    description: '配置和管理AI模型相关设置',
    placeholder: '模型配置页面（待开发）'
  },
  conversations: {
    dateRange: '时间范围',
    rangeSeparator: '至',
    startDate: '开始日期',
    endDate: '结束日期',
    status: '状态',
    statusAll: '全部',
    statusActive: '活跃',
    statusExpired: '过期',
    search: '搜索',
    searchPlaceholder: '请输入会话ID或IP地址',
    conversationId: '会话ID',
    ipAddress: 'IP地址',
    location: '地理位置',
    messageCount: '消息数',
    createdAt: '创建时间',
    lastAccessTime: '最后访问',
    viewDetail: '查看详情',
    detailTitle: '会话详情',
    messages: '消息列表',
    userMessage: '用户消息',
    aiResponse: 'AI回复',
    audioMessage: '语音消息',
    success: '成功',
    failed: '失败',
    liked: '已点赞',
    disliked: '已点踩',
    dislikeReason: '点踩原因',
    dislikeDetail: '详细说明',
    dislikeOption1: '回答不准确',
    dislikeOption2: '没有帮助',
    dislikeOption4: '其他',
    dislikeOptionUnknown: '未知',
    noMessages: '暂无消息',
    expand: '展开',
    collapse: '收起',
    audioNotSupported: '您的浏览器不支持音频播放',
    unknownMessageType: '未知消息类型'
  },
  feedbackRecords: {
    title: '反馈记录',
    description: '查看用户对AI回答的反馈评价',
    conversationId: '会话ID',
    answerTime: '问答时间',
    questionContent: '提问内容',
    answerContent: '回答内容',
    feedbackStatus: '点评状态',
    feedbackStatusFilter: '点评状态',
    feedbackStatusPlaceholder: '请选择点评状态',
    all: '全部',
    feedbackCategory: '反馈类别',
    dislikeReason: '不喜欢原因',
    actions: '操作',
    liked: '喜欢',
    disliked: '不喜欢',
    feedbackCategory1: '回答不准确',
    feedbackCategory2: '没有帮助',
    feedbackCategory3: '人工客服',
    feedbackCategory4: '其他',
    feedbackCategoryUnknown: '未知',
    viewDetail: '查看详情',
    viewConversation: '查看问答记录',
    searchPlaceholder: '请输入会话ID',
    noData: '暂无反馈记录',
    dateRange: '时间范围',
    rangeSeparator: '至',
    startDate: '开始日期',
    endDate: '结束日期',
    search: '搜索',
    reset: '重置',
    loading: '加载中...',
    questionTypeImage: '[图片]',
    questionTypeAudio: '[语音]',
    download: '下载',
    exportSuccess: '导出成功',
    exportFailed: '导出失败'
  },
  modelTraining: {
    title: '模型训练',
    description: '上传标注好的ZIP包，系统将自动训练模型并部署',
    currentModel: {
      title: '当前使用的模型',
      modelName: '模型名称',
      modelId: '模型ID',
      deployedAt: '部署时间',
      modelPath: '模型路径',
      defaultModel: '默认模型（捷昌）',
      notDeployed: '未部署',
      switchToDefault: '切换回捷昌默认模型',
      switchToDefaultConfirm: '确定要切换回捷昌默认模型吗？当前部署的自定义模型将被取消部署。',
      switchToDefaultSuccess: '切换回默认模型成功',
      switchToDefaultFailed: '切换回默认模型失败'
    },
    upload: {
      title: '上传数据集',
      dragText: '点击或拖拽ZIP文件到此处上传',
      hint: '支持从 Label Studio 导出的 YOLO 格式 ZIP 文件，最大 2GB',
      uploading: '正在上传...',
      fileTypeError: '只能上传ZIP文件',
      fileSizeError: '文件大小不能超过 2GB',
      uploadSuccess: '上传成功，训练已启动',
      uploadFailed: '上传失败'
    },
    uploadModel: {
      title: '上传已训练模型',
      dragText: '点击或拖拽 .pt 文件到此处上传',
      hint: '直接上传训练好的 .pt 模型，仅支持部署、不支持测试',
      uploading: '正在上传...',
      fileTypeError: '只能上传 .pt 文件',
      uploadSuccess: '上传成功，可直接部署',
      uploadFailed: '上传失败'
    },
    tasks: {
      title: '训练任务列表',
      taskId: '任务ID',
      fileName: '文件名',
      status: '状态',
      progress: '进度',
      trainingStartTime: '训练开始时间',
      trainingEndTime: '训练结束时间',
      createdAt: '创建时间',
      actions: '操作',
      test: '测试',
      deploy: '部署',
      download: '下载',
      delete: '删除',
      viewError: '查看错误',
      refresh: '刷新',
      training: '训练中...',
      waiting: '等待中...',
      downloading: '正在下载模型...',
      downloadSuccess: '下载成功',
      downloadFailed: '下载失败',
      cannotDeleteDeployed: '已部署的模型不能删除，请先取消部署',
      deleteConfirm: '确定要删除此任务吗？此操作不可恢复。',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败'
    },
    status: {
      pending: '等待中',
      training: '训练中',
      completed: '已完成',
      failed: '失败',
      unknown: '未知',
      deployed: '✅ 已部署'
    },
    test: {
      title: '测试模型',
      uploadImage: '上传测试图片',
      recognizing: '正在识别中...',
      recognized: '识别完成',
      testFailed: '测试失败',
      imageOnly: '只能上传图片文件',
      detected: '检测到',
      notDetected: '未检测到目标',
      result: '识别结果',
      predictions: '所有预测结果',
      category: '类别',
      confidence: '置信度'
    },
    deploy: {
      title: '部署模型',
      taskId: '任务ID',
      fileName: '文件名',
      modelPath: '模型路径',
      hint: '部署后，系统将使用此模型进行图片识别。模型文件已自动下载到服务器。',
      warning: '注意：当前已有部署的模型，部署新模型将替换当前使用的模型。',
      confirm: '确认部署',
      cancel: '取消',
      deploying: '部署中...',
      deploySuccess: '部署成功',
      deployFailed: '部署失败'
    },
    error: {
      title: '训练错误信息',
      details: '错误详情'
    }
  }
}

